import {
  screenNameConstants,
  viewPathConstants,
  CenterStatusEnum,
} from "../../constants";
import CenterInstructors from "./Views/CenterInstructors/CenterInstructors";
import CenterStudents from "./Views/CenterCourses/Students";
import CenterActivity from "./Views/CenterActivity/CenterActivity";
import CenterProfile from "../AdminPortal/Views/CenterProfile/CenterProfile";

export const CenterRoutes = (UserData) => {
  const defaultNavLinks = [
    {
      path: viewPathConstants.CENTER_PROFILE,
      name: screenNameConstants.CENTER_PROFILE,
      component: <CenterProfile />,
      protected: true,
      hasSideBar: true,
    },
  ];

  // private routes
  if (
    UserData?.centerStatus === CenterStatusEnum.Approved ||
    UserData?.centerStatus === CenterStatusEnum.PaymentRejected ||
    UserData?.centerStatus === CenterStatusEnum.Restricted
  ) {
    defaultNavLinks.push(
      {
        path: viewPathConstants.CENTER_INSTRUCTORS,
        name: screenNameConstants.INSTRUCTORS,
        component: <CenterInstructors />,
        protected: true,
        hasSideBar: true,
      },
      {
        path: viewPathConstants.CENTER_STUDENTS,
        name: screenNameConstants.MY_STUDENTS,
        component: <CenterStudents />,
        protected: true,
        hasSideBar: true,
      },
      {
        path: viewPathConstants.CENTER_ACTIVITY,
        name: screenNameConstants.CENTER_ACTIVITY,
        component: <CenterActivity />,
        protected: true,
        hasSideBar: true,
      },
    );
  }

  return defaultNavLinks;
};
